import Vue from 'vue';
import VueScrollmagic from 'vue-scrollmagic';
Vue.use(VueScrollmagic, { globalSceneOptions: { triggerHook: 'onEnter', duration: '200%' } });
